

import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  Chip,
  Box,
  styled,
  IconButton,
  Tooltip
} from '@mui/material';
import { 
  Edit,
  Save,
  Close
} from "@mui/icons-material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

const GradientCard = styled(Card)({
  overflow: 'hidden',
  position: 'relative',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    background: 'linear-gradient(135deg, #E3F2FD, #90CAF9, #42A5F5, #1E88E5)',
    opacity: 0.9,
  },
});

const StyledTypography = styled(Typography)({
  fontWeight: 700,
  letterSpacing: '0.5px',
  color: '#0D47A1',
  textShadow: '1px 1px 2px rgba(255,255,255,0.5)',
});

export default function SimpleOrderHeader({ 
  orderNumber, 
  status, 
  onEdit,  // Add onEdit prop
  extraActions // Optional prop for additional actions
}) {
  // Helper function to get status color
  const getStatusColor = (status) => {
    switch(status?.toLowerCase()) {
      case 'draft': return 'warning';
      case 'in_progress': return 'info';
      case 'completed': return 'success';
      case 'cancelled': return 'error';
      default: return 'default';
    }
  };

  return (
    <Card>
      <MDBox
        mx={2}
        mt={-3}
        py={3}
        px={2}
        variant="gradient"
        bgColor="info"
        borderRadius="lg"
        coloredShadow="info"
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <MDTypography variant="h6" color="white">
          {orderNumber}
        </MDTypography>
        
        <Box display="flex" alignItems="center">
          {/* Status Chip */}
          {/* <Chip 
            label={status} 
            color={getStatusColor(status)}
            sx={{ 
              mr: 2, 
              color: 'white', 
              backgroundColor: 'rgba(255,255,255,0.2)' 
            }}
          /> */}

          {/* Edit Button */}
          {/* <Tooltip title="Edit Order">
            <IconButton 
              onClick={onEdit}
              sx={{
                backgroundColor: "rgba(255,255,255,0.2)",
                color: "white",
                borderRadius: "50%",
                transition: "background-color 0.3s ease",
                "&:hover": {
                  backgroundColor: "rgba(255,255,255,0.3)",
                }
              }}
            >
              <Edit />
            </IconButton>
          </Tooltip> */}

          {/* Extra Actions (if any) */}
          {extraActions}
        </Box>
      </MDBox>
    </Card>
  );
}